import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import StatelessTextInput from "@cirrus/legacy/app-components/form-controls/inputs/stateless-text-input/index.jsx"
import Button from "@cirrus/legacy/app-components/buttons/button/index.jsx"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import FilterAutosuggest from "./filterAutosuggest.jsx"

import styles from "./index.less"
import Content from "./content.jsx"

class Search extends C {
  constructor(props) {
    super(props)

    this.state = {
      showContent: props.showContentDefault,
    }
  }
  static propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool,
    onRequestSearch: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyUp: PropTypes.func,
    dataQa: PropTypes.string,
    children: PropTypes.node,
    containerWidth: PropTypes.number,
    onFilter: PropTypes.func,
    searchDisabled: PropTypes.bool,
    isFiltered: PropTypes.bool,
    filterSuggestions: PropTypes.object,
    smallSearch: PropTypes.bool,
    handleResetSearchFilter: PropTypes.func,
  }

  static defaultProps = {
    searchDisabled: false,
  }

  state = {
    showContent: false,
    searchFocused: false,
  }

  handleOpenDialog = (event) => {
    if (this.state.showContent) {
      return
    }

    event.preventDefault()

    this.setState({
      showContent: true,
    })
  }

  handleHideDialog = () => {
    this.setState({
      showContent: false,
    })

    this.props.onClose && this.props.onClose()
  }

  handleChangeInput = (e, value) => {
    if (this.props.onChange) {
      this.props.onChange(e, value)
    }
  }

  handleKeyUp = (e) => {
    if (e.which === 13 && !this.props.searchDisabled) {
      this.props.onFilter()
    }
  }

  getClass() {
    return classnames(styles.searchContainer, this.props.className, styles.smallSearch)
  }

  getInputClass() {
    return classnames(styles.searchInput, {
      [styles.searchFocused]: this.state.searchFocused,
    })
  }

  getSearchButtonClass() {
    return classnames(styles.search, {
      [styles.searchFocused]: this.state.searchFocused,
    })
  }

  focusSearch = () => {
    const { onFocus } = this.props
    onFocus && onFocus()

    this.setState({
      searchFocused: true,
    })
  }

  blurSearch = () => {
    this.setState({
      searchFocused: false,
    })
  }

  render() {
    let {
      value,
      autoFocus,
      dataQa,
      placeholder,
      children,
      containerWidth,
      onFilter,
      isFiltered,
      searchDisabled,
      filterSuggestions,
    } = this.props

    let inputProps = {
      setRef: this.props.setRef,
      autoFocus,
      onChange: this.handleChangeInput,
      onKeyUp: this.handleKeyUp,
      onFocus: this.focusSearch,
      onBlur: this.blurSearch,
      className: this.getInputClass(),
      value: value || "",
      placeholder: placeholder,
      dataQa: `${dataQa}-input`,
    }

    const useResetButton =
      this.props.handleResetSearchFilter && (inputProps.value !== "" || isFiltered)

    let renderInputComponent = (inputProps) => (
      <div
        className={classnames(styles.inputContainer, {
          [styles.searchFocused]: this.state.searchFocused,
        })}>
        <StatelessTextInput {...inputProps} />
        {useResetButton ? (
          <Button
            className={classnames(styles.resetButton, "icon icon-cross2")}
            onClick={this.props.handleResetSearchFilter}
          />
        ) : null}
        {children && (
          <Button
            className={classnames(styles.openDialogButton, "icon", {
              "icon-filter3": isFiltered,
              "icon-filter4": !isFiltered,
            })}
            onClick={this.handleOpenDialog}
            dataQa="search-dialog-filter"
          />
        )}
        <Button
          className={this.getSearchButtonClass()}
          disabled={searchDisabled}
          onClick={onFilter}
          dataQa="search-dialog-button"
          type="filled-success">
          <Icon className={styles.searchIcon} icon="fa-search" />
        </Button>
        {this.state.showContent && children && (
          <Content close={this.handleHideDialog} containerWidth={containerWidth}>
            {children}
          </Content>
        )}
      </div>
    )

    return (
      <div
        className={this.getClass()}
        data-qa={dataQa}
        style={containerWidth ? { width: containerWidth + 42 + "px" } : null}>
        {filterSuggestions != null ? (
          <FilterAutosuggest
            filterSuggestions={filterSuggestions}
            inputProps={inputProps}
            renderInputComponent={renderInputComponent}
          />
        ) : (
          renderInputComponent(inputProps)
        )}
      </div>
    )
  }
}

export default Search
